<template>
  <div
    v-if="attachment && key"
    class="biodigital-component-container"
  >
    <iframe
      :id="iframeId"
      allowfullscreen="true"
      :src="source"
    />
  </div>
</template>

<script>
  export default {
    props: {
      attachment: {
        type: Object,
      },
    },
    data() {
      return {
        humanAPIObject: null,
        start: new Date(),
      };
    },
    computed: {
      eventParams() {
        return {
          'ID': this.attachment.metadata.contentId,
          'Title': this.attachment.metadata.contentTitle,
        };
      },
      iframeId() {
        return `biodigital-frame-${this.attachment.id}`;
      },
      key() {
        return process.env.HUMANKIT_WEB_KEY;
      },
      source() {
        return `https://human.biodigital.com/viewer/?be=${this.attachment.metadata.contentId}&dk=${this.key}`;
      },
    },
    mounted() {
      this.loadScript();
      this.$analytics.events.biodigitalViewedModel(this.eventParams);
    },
    beforeUnmount() {
      const time = Math.ceil((new Date() - this.start) / 1000);
      this.$analytics.events.biodigitalDismissedModel({ 'Time Spent Viewing': time, ...this.eventParams });
    },
    methods: {
      loadScript() {
        const scriptId = 'biodigitalmathmlscript';
        if (document.getElementById(scriptId)) {
          this.setupHumanAPI();
        } else {
          let script = document.createElement('script');
          script.id = scriptId;
          script.type = 'text/javascript';
          const context = this;
          script.onload = function() {
            context.setupHumanAPI();
          };

          script.src = 'https://developer.biodigital.com/builds/api/2/human-api.min.js';
          document.getElementsByTagName('head')[0].appendChild(script);
        }
      },
      setupHumanAPI() {
        this.humanAPIObject = new HumanAPI(this.iframeId);
        const context = this;

        // https://developer.biodigital.com/docs/widget/reference/namespaces/human#.event:ready
        this.humanAPIObject.on('human.ready', function() {

          let lastSelectedState = {};

          // https://developer.biodigital.com/docs/widget/reference/namespaces/scene#.event:objectsSelected
          this.on('scene.objectsSelected', function(data) {
            // the data object will have multiple keys, if a value is false it means it was deselected
            // if a value is true it means it is currently selected, but we must compare with the previous
            // event data to see if it was the object that was most recently selected

            Object.keys(data).filter(key => !data[key]).forEach(key => {
              const params = { 'Object ID': key, ...context.eventParams };
              context.$analytics.events.biodigitalDeselectedObject(params);
            });

            const selectedId = Object.keys(data).find(key => data[key] && !lastSelectedState[key]);
            if (selectedId) {
              const params = { 'Object ID': selectedId, ...context.eventParams };
              context.$analytics.events.biodigitalSelectedObject(params);
            }

            lastSelectedState = data;
          });

          // https://developer.biodigital.com/docs/widget/reference/namespaces/timeline#.event:chapterTransition
          this.on('timeline.chapterTransition' , function(data) {
            const params = { 'Chapter ID': data.currentChapter, ...context.eventParams };
            context.$analytics.events.biodigitalTransitionedChapter(params);
          });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
// https://benmarshall.me/responsive-iframes/
.biodigital-component-container {
  overflow: hidden;
  padding-top: 80%;
  position: relative;

  @include breakpoint(small) {
    padding-top: 100%;
  }

  iframe {
    border: 0;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
}
</style>